import React from 'react';
import { baseConfig } from '../../config/algolia';
import { InstantSearch, Configure } from 'react-instantsearch';
import PageFlyHits from './PageFlyHits';
import { InsightsMiddleware } from '../../utils/algolia/InsightsMiddleware';
import { searchClientWithProxy } from '../../utils/algolia/createInstantSearchProxy';

const { product_families_index } = baseConfig;
//PNP-1873 - sku has been passed from pagefly.js where element with data-pagefly-sku attribute exists.
const PageFlyContainer = ({ skuNodes }) => {
  const algoliaSearchClient = searchClientWithProxy();
  const indexName = product_families_index;
  const hitsPerPage = window.Jbhifi.pageflyHitsLimit ?? 100;

  //PNP-1873 - render using indices specified through to PageFlyHits with React Instant search
  return (
    <InstantSearch searchClient={algoliaSearchClient} indexName={indexName}>
      <InsightsMiddleware />
      <Configure
        clickAnalytics
        hitsPerPage={Math.min(hitsPerPage, 500)}
        query=""
        filters={
          skuNodes
            .map(node => `sku: ${node.dataset.pageflySku} OR skus: ${node.dataset.pageflySku} OR `)
            .join('')
            .slice(0, -4) + ' AND (price > 0 AND product_published = 1 AND availability.displayProduct = 1)'
        }
        distinct
      />
      <PageFlyHits skuNodes={skuNodes} />
    </InstantSearch>
  );
};

export default PageFlyContainer;
